// extracted by mini-css-extract-plugin
module.exports =  {"projectCard":"style-module_projectCard__v2ZuzMVIug0maFQ5aQaT"};